import React from 'react';
import './action-list-view.scss';
import { TouchableOpacity, View, Text } from '../../common';
import { Divider } from '..';
import { FileUploadOutput } from '@zonofi/zono-money-store';

interface ActionItem {
  icon: string;
  text: string;
  textClass?: string;
  onPress: () => void;
}

interface ActionListViewProps {
  actions?: ActionItem[];
  shouldShowFile?: boolean;
  selectedMediaItem?: FileUploadOutput;
  containerClassName?: string;
  imageClassName?: string;
}

export const ActionListView: React.FC<ActionListViewProps> = ({
  actions = [],
  shouldShowFile = false,
  selectedMediaItem,
  containerClassName = '',
  imageClassName = 'action-list--image',
}) => {
  const fileType = selectedMediaItem?.type ?? selectedMediaItem?.file?.type;
  const fileUri = selectedMediaItem?.uri;

  const isImage = fileType?.startsWith('image/');
  const isPdf = fileType === 'application/pdf';

  return (
    <View
      className={`action-list-container ${
        shouldShowFile ? 'show-image' : ''
      } ${containerClassName}`}
    >
      <View className="action-list-inner">
        {shouldShowFile && fileUri ? (
          <>
            {isImage && (
              <img src={fileUri as string} className={imageClassName} />
            )}
            {isPdf && (
              <iframe
                src={`${fileUri}#toolbar=0&navpanes=0&scrollbar=0`}
                title="PDF Preview"
                width="100%"
                height="425px"
                style={{ border: 'none' }}
              />
            )}
          </>
        ) : (
          actions.map((action, index) => (
            <React.Fragment key={index}>
              <TouchableOpacity
                className="action-list-item"
                onPress={action.onPress}
              >
                <img src={action.icon} width={20} height={20} />
                <Text
                  className={`action-list-item--text font-regular ${action.textClass}`}
                >
                  {action.text}
                </Text>
              </TouchableOpacity>
              {index < actions.length - 1 && <Divider />}
            </React.Fragment>
          ))
        )}
      </View>
    </View>
  );
};
